// Shared chrome for the Security surfaces (findings review and finding cards):
// one focus ring, a transition list that leaves the ring out of the
// fade, and the house text voices. Eyebrows and notes are proportional,
// like the rest of the product; mono is reserved for ids, paths, keys,
// and quoted lines.
import { EYEBROW_CLASS, NOTE_CLASS } from "./ui.js";

export const DOCKET_FOCUS =
    "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[1px] focus-visible:outline-[color:var(--green)]";
export const DOCKET_TRANSITION =
    "transition-[color,background-color,border-color,box-shadow] duration-150";
// Section and panel eyebrow — the context panel's own.
export const SECTION_EYEBROW_CLASS =
    "text-[10px] leading-[1.1] tracking-[0.06em] uppercase text-[color:var(--eyebrow)]";
export const DOCKET_EYEBROW_CLASS = EYEBROW_CLASS;
export const DOCKET_NOTE_CLASS = NOTE_CLASS;
// Same note voice on a tinted surface (active row), where the soft tint
// drops under AA.
export const DOCKET_NOTE_STRONG_CLASS = "text-[11px] leading-[1.22] text-[color:var(--muted)]";
export const ID_CLASS = "font-mono text-[11px] leading-[1.3] tabular-nums text-[color:var(--muted-soft)]";
